import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import Image from "../../elements/image";
import Videojs from "../video-js";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import gsap from 'gsap';
import { mobileIs, loadScrollMagic } from "../../utils/siteUtils";

import "./style.scss";
let videoLoadStatus = false;
const VideoPlay = props => {
  const  { video, poster, title, verticalScreen, titleMobile, MobilePoster, MobileVideo, autoplay } = props.fields
  const rootEl = useRef();
  const videoEl = useRef();
  const titleEl = useRef();
  const titleMainEl = useRef();
	const [showControl, setShowControl] = useState(false);
  
  const videoMainEl = useRef();
  const isMobile = mobileIs();
	let videoOptions = 
  ( video && video.value) 
    ? {
        sources: [
        {
          src: video.value.src,
          type: video.value.mimeType
        }
        ],
        poster:  poster ? poster.value.src : null,
        videoTitle: '',
        autoplay: autoplay.value,
        controls: autoplay.value == true ? false : true,
        muted: true,
        loop: true
  }: null;
	let videoOptionsMobile = 
  ( MobileVideo && MobileVideo.value) 
    ? {
        sources: [
        {
          src: MobileVideo.value.src,
          type: MobileVideo.value.mimeType
        }
        ],
        poster:  MobilePoster ? MobilePoster.value.src : null,
        videoTitle: '',
        autoplay: autoplay.value,
        controls: autoplay.value == true ? false : true,
        muted: true,
        loop: true
  }: null;
  useEffect(() => {
    let ScrollMagic, controller, scene, scene2, tl, tl2, titleTl;
    ScrollMagic = loadScrollMagic();
    tl = gsap.timeline();
    tl2 = gsap.timeline();
    titleTl = gsap.timeline({paused: true});
    titleTl.to(titleEl.current,{
      display: 'none'
    })
    if(isMobile){
      tl.to(videoMainEl.current,{
        margin: 0,
        width: window.innerWidth,
        height: window.innerHeight,
      },'first')
      .to(titleEl.current,{
        opacity: 0,
        scale: 0,
        zIndex: 0,
      },'first')
      .to(videoMainEl.current,{
        margin: 0,
        width: window.innerWidth,
        height: window.innerHeight,
      },'second')
      .to(videoMainEl.current,{
        margin: 0,
        width: window.innerWidth,
        height: verticalScreen?.value ? window.innerWidth * 0.5625 : window.innerHeight,
      },'three')
    }else{
      tl.to(videoMainEl.current,{
        width: window.innerWidth,
        height: window.innerHeight,
      },'first')
      
      .to(videoMainEl.current,{
        width: window.innerWidth,
        height: window.innerHeight,
      },'second')
      .to(videoMainEl.current,{
        width: window.innerWidth,
        height: window.innerHeight,
      },'three')
      tl2.to(titleEl.current,{
        opacity: 1,
        scale: 0,
        zIndex: 0,
        ease: 'linear'
      },'first')
    }

    controller = new ScrollMagic.Controller();
    scene = new ScrollMagic.Scene({
      triggerElement: rootEl.current,
      triggerHook: 0,
      duration: '100%'
    })
    .setPin(rootEl.current)
    .setTween(tl)
    .addTo(controller);
    scene2 = new ScrollMagic.Scene({
      triggerElement: rootEl.current,
      triggerHook: 0,
      offset: '150',
      duration: '150'
    })
    .setTween(tl2)
    .addTo(controller);
    scene.on("progress", function(event) {
      let ep = event.progress;
      let es = event.scrollDirection;
      if( ep > 1/3 && videoEl.current && videoLoadStatus && autoplay.value){
        videoEl.current.player.play()
      }
      if( ep > 1/3 && videoEl.current){
        if(isMobile){
          titleTl.play()
        }
        setTimeout(v=>{
          setShowControl(true)
        },100)
      }
      if( ep < 1/3 && es === 'REVERSE' && videoEl.current){
        videoEl.current.player.pause()
        titleTl.reverse()
        setShowControl(false)
      }
    })
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      scene && scene.destroy(true);
      scene = null;
      controller.destroy(true);
      controller = null;
    }
  }, []);
  const videoLoaded = () => {
    videoLoadStatus = true
  }
  const onScroll = () => {
    if(rootEl.current && videoEl?.current){
      let top = rootEl.current.getBoundingClientRect().top;
      let height = rootEl.current.getBoundingClientRect().height;
      if( Math.abs(top) > window.innerHeight && top<0){
        videoEl.current.player.pause()
      }
      if( Math.abs(top) < window.innerHeight && top>0){
        videoEl.current.player.pause()
      }
    }
  }
  return (
    <div className="VideoPlay" datasourceid={props.rendering.dataSource}>
      <div className="VideoPlay-content" ref={rootEl}>
        <div className={classNames("VideoPlay-video",showControl? null : 'hideControl')} ref={videoMainEl}>          
          { ((!isMobile && video && !video.value) || (MobileVideo && !MobileVideo.value && isMobile)) && 
            <Image className="img" id={'VideoPlay-videoMediaModel'} { ...isMobile ? MobilePoster.value : poster.value} />
          }
          { ((!isMobile && video && video.value) || (MobileVideo && MobileVideo.value && isMobile)) && 
            <Videojs {...isMobile ? videoOptionsMobile : videoOptions}  id={'VideoPlay-videoMediaModel'} videoLoaded={videoLoaded} ref={videoEl}/>
          }
          
        </div>
        { ((isMobile && titleMobile.value!='') || (!isMobile && title.value!='') )&&
          <div className="title" ref={titleEl}>
            <div ref={titleMainEl}>
              <RichText tag="div" field={isMobile ? titleMobile : title} />
            </div>
          </div>
        }
      </div>
    </div>
  )
};
export default VideoPlay;
